import { render } from "./PlanFormModal.vue?vue&type=template&id=6a38a24c"
import script from "./PlanFormModal.vue?vue&type=script&lang=js"
export * from "./PlanFormModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__